import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'amountCurrency',
  standalone: true,
})
export class AmountCurrencyPipe implements PipeTransform {
  transform(
    value: number | null | undefined,
    currencySymbol: string = '€',
    currencySymbolPosition: 'before' | 'after' = 'after',
    locale: string | undefined = undefined,
    minFractionDigits: number = 2,
    maxFractionDigits: number = 2
  ): string {
    if (value === null || value === undefined || isNaN(value)) {
      return '--';
    }

    const formatted = value.toLocaleString(locale, {
      minimumFractionDigits: minFractionDigits,
      maximumFractionDigits: maxFractionDigits,
    });

    return `${currencySymbolPosition === 'before' ? currencySymbol : ''}${formatted}${currencySymbolPosition === 'after' ? currencySymbol : ''}`;
  }
}
